import { HostAPIBase } from './HostAPIBase';

export class HostAPIClassic extends HostAPIBase {}
